import { IProduct } from "../products.interface";
import { Checkbox } from "@/components/ui/checkbox";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import {
  setAddProductModal,
  setSelectedProduct,
  setSelectedProducts,
} from "../products.slice";
import { Button } from "@/components/ui/button";
import { Loader2, Pencil, Trash2 } from "lucide-react";
import { useEffect, useState } from "react";
import DeleteProduct from "./DeleteProduct";
import { getProduct } from "../products.action";
import { toast } from "sonner";

export default function ProductRow({ product }: { product: IProduct }) {
  // Hooks
  const dispatch = useAppDispatch();

  // Redux
  const { selectedProducts, getProductError, selectedProduct } = useAppSelector(
    (state) => state.products
  );

  // Local state
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isGetProductLoading, setIsGetProductLoading] = useState(false);

  const onSelectRow = (checked: boolean, id: string) => {
    if (checked) {
      dispatch(setSelectedProducts([...selectedProducts, id]));
    } else {
      dispatch(
        setSelectedProducts(selectedProducts.filter((item) => item !== id))
      );
    }
  };

  useEffect(() => {
    if (selectedProduct) {
      setIsGetProductLoading(false);
      dispatch(setSelectedProduct(selectedProduct));
      dispatch(setAddProductModal(true));
    }

    if (getProductError) {
      toast.error(getProductError);
    }
  }, [selectedProduct]);

  return (
    <div
      key={product._id}
      className="grid grid-cols-(--product-table-header) gap-4 p-4 border-b last:border-b-0 items-center"
    >
      <Checkbox
        className="border-primary"
        checked={selectedProducts.includes(product._id)}
        onCheckedChange={(e) => onSelectRow(e as boolean, product._id)}
      />
      <div className="text-center text-sm font-medium">{product.batch}</div>
      <div className="text-center text-sm font-medium truncate">
        {product.name}
      </div>
      <div className="text-center text-sm font-medium truncate">
        {product.costPrice}
      </div>
      <div className="text-center text-sm font-medium truncate">
        {product.mrp}
      </div>
      <div className="text-center text-sm font-medium truncate">
        {new Date(product.expiryDate).toLocaleDateString()}
      </div>
      <div className="text-center text-sm font-medium">
        {product.manufacturer}
      </div>
      <div className="flex items-center justify-around">
        <Button
          variant={"ghost"}
          size={"sm"}
          onClick={() => {
            setIsGetProductLoading(true);
            dispatch(getProduct(product._id));
          }}
        >
          {isGetProductLoading ? (
            <Loader2 className="animate-spin" />
          ) : (
            <Pencil />
          )}
        </Button>

        <Button
          variant={"ghost"}
          size={"sm"}
          onClick={() => setIsDeleteOpen(true)}
        >
          <Trash2 />
        </Button>

        <DeleteProduct
          id={product._id}
          isDeleteOpen={isDeleteOpen}
          setIsDeleteOpen={setIsDeleteOpen}
        />
      </div>
    </div>
  );
}
